webpackJsonp([275],{

/***/ 1016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternAuditPerformanceTable_vue__ = __webpack_require__(2532);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c2b8efa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternAuditPerformanceTable_vue__ = __webpack_require__(3260);
function injectStyle (ssrContext) {
  __webpack_require__(3256)
  __webpack_require__(3258)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c2b8efa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternAuditPerformanceTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c2b8efa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternAuditPerformanceTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 2532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_components_RemoteSelect_vue__ = __webpack_require__(248);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RemoteSelect: __WEBPACK_IMPORTED_MODULE_3__core_components_RemoteSelect_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table_v3__["a" /* default */]],
  data: function data() {
    return {
      search: {
        stat_month: null,
        customerid: null,
        projectid: null,
        score_min: '',
        score_max: '',
        intern_user_id: null,
        order_by: null,
        order_dir: null
      },
      searchFieldType: {
        customerid: String,
        projectid: String,
        intern_user_id: Number
      },
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0
      },
      formRules: {
        score_min: [{ validator: this.validateScoreBound, trigger: 'blur' }],
        score_max: [{ validator: this.validateScoreBound, trigger: 'blur' }]
      },
      ignoreSortChange: false,
      recalculating: false,
      exportHeader: [{ key: 'id', text: 'ID' }, { key: 'intern_text', text: '实习生' }, { key: 'stat_month', text: '出勤月份' }, { key: 'customer_name', text: '客户' }, { key: 'project_text', text: '项目' }, { key: 'audit_order_total', text: '审核工单总数' }, { key: 'is_full_attendance_text', text: '是否全勤' }, { key: 'plan_order_total', text: '累计审核目标' }, { key: 'pass_count', text: '通过次数' }, { key: 'reject_count', text: '不通过次数' }, { key: 'first_audit_count', text: '初审次数' }, { key: 'review_audit_count', text: '复审次数' }, { key: 'wrong_order_total', text: '误审单量' }, { key: 'days_target_achieved', text: '目标达成天数' }, { key: 'days_target_onduty', text: '项目出勤天数' }, { key: 'achieve_rate_text', text: '目标达成率（得分）' }, { key: 'error_rate_text', text: '错误率（得分）' }, { key: 'attendance_score', text: '月度出勤得分' }, { key: 'total_score', text: '审单绩效总分' }]
    };
  },

  computed: {
    projectSelectKey: function projectSelectKey() {
      return 'project-' + (this.search.customerid || 'all');
    },
    defaultSort: function defaultSort() {
      if (!this.search.order_by || !this.search.order_dir) {
        return {};
      }
      return {
        prop: this.search.order_by,
        order: this.search.order_dir === 'asc' ? 'ascending' : 'descending'
      };
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable', 'getCustomerDetail', 'getProjectTable', 'getProjectDetail', 'queryInternTableApi', 'getInternBaseInfoApi', 'queryInternAuditPerformanceApi']), {
    getTableData: function getTableData(params) {
      return request.common('queryInternAuditPerformanceApi', params);
    },
    setTableData: function setTableData(_ref) {
      var _this = this;

      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
      this.$nextTick(function () {
        _this.syncTableSort();
      });
    },
    queryProjectTable: function queryProjectTable(params) {
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, params);
      if (this.search.customerid) {
        query.customerid = this.search.customerid;
      }
      return this.getProjectTable(query);
    },
    onCustomerChange: function onCustomerChange() {
      this.search.projectid = null;
    },
    onProjectChange: function onProjectChange(project) {
      if (!project || !project.customerid) {
        return;
      }
      this.search.customerid = String(project.customerid);
    },
    onSortChange: function onSortChange(_ref2) {
      var prop = _ref2.prop,
          order = _ref2.order;

      if (this.ignoreSortChange) {
        return;
      }
      var nextBy = order ? prop : null;
      var nextDir = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : null;
      if (this.search.order_by === nextBy && this.search.order_dir === nextDir) {
        return;
      }
      this.search.order_by = nextBy;
      this.search.order_dir = nextDir;
      this.onSearch();
    },
    onManualRecalculate: function onManualRecalculate() {
      var _this2 = this;

      var now = new Date();
      var month = this.search.stat_month || now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
      this.$confirm('\u786E\u8BA4\u91CD\u65B0\u8BA1\u7B97 ' + month + ' \u7684\u5BA1\u5355\u7EE9\u6548\uFF1F', '重新手动计算', {
        type: 'warning',
        confirmButtonText: '确认计算',
        cancelButtonText: '取消'
      }).then(function () {
        _this2.recalculating = true;
        return request.common('recalculateInternAuditPerformanceApi', { stat_month: month }).then(function (_ref3) {
          var data = _ref3.data;

          _this2.$message.success(month + ' \u5DF2\u91CD\u65B0\u8BA1\u7B97 ' + data.count + ' \u6761');
          _this2.onRefresh();
        }).finally(function () {
          _this2.recalculating = false;
        });
      }).catch(function () {});
    },
    onExport: function onExport() {
      var _this3 = this;

      this.$export('导出审单绩效统计', {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.queryInternAuditPerformanceApi,
        requestParams: Object(__WEBPACK_IMPORTED_MODULE_2__core_mixins_table_v3__["b" /* removeEmptyParams */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_mixins_table_v3__["c" /* trimParams */])(_.cloneDeep(this.search))),
        getResponseData: function getResponseData(data) {
          data.data = data.data.map(function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, row, {
              intern_text: _this3.internText(row),
              project_text: _this3.projectText(row),
              is_full_attendance_text: Number(row.is_full_attendance) === 1 ? '是' : '否'
            });
          });
          return data;
        }
      });
    },
    resetSearch: function resetSearch() {
      this.$refs.searchForm.resetFields();
      this.search.order_by = null;
      this.search.order_dir = null;
      if (this.$refs.performanceTable) {
        this.$refs.performanceTable.clearSort();
      }
      this.onSearch();
    },
    internText: function internText(row) {
      var name = row.intern_name || '';
      var id = row.intern_user_id;
      return name ? name + '/' + id : id != null && id !== '' ? String(id) : '';
    },
    projectText: function projectText(row) {
      var name = row.project_name || '';
      var number = row.project_number || '';
      if (name && number) {
        return name + '/' + number;
      }
      return name || number;
    },
    validateScoreBound: function validateScoreBound(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback();
        return;
      }
      var text = String(value).trim();
      if (text === '' || isNaN(Number(text))) {
        callback(new Error('请输入数字'));
        return;
      }
      if (rule.field !== 'score_max') {
        callback();
        return;
      }
      var minText = String(this.search.score_min).trim();
      if (minText !== '' && !isNaN(Number(minText)) && Number(minText) > Number(text)) {
        callback(new Error('最低分不能大于最高分'));
        return;
      }
      callback();
    },
    syncTableSort: function syncTableSort() {
      var table = this.$refs.performanceTable;
      if (!table || !this.search.order_by || !this.search.order_dir) {
        return;
      }
      var order = this.search.order_dir === 'asc' ? 'ascending' : 'descending';
      this.ignoreSortChange = true;
      table.sort(this.search.order_by, order);
      this.ignoreSortChange = false;
    }
  })
});

/***/ }),

/***/ 3256:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3257);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("70b0c5d5", content, true, {});

/***/ }),

/***/ 3257:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".score-range[data-v-5c2b8efa]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.score-range .el-input[data-v-5c2b8efa]{width:120px}.score-range span[data-v-5c2b8efa]{margin:0 8px;color:#909399}.score-range-item[data-v-5c2b8efa]{margin-bottom:0}.attendance-no[data-v-5c2b8efa],.attendance-yes[data-v-5c2b8efa]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:2px 8px;border-radius:999px;font-size:12px;line-height:1}.attendance-yes[data-v-5c2b8efa]{background:#e8fff3;color:#00b42a}.attendance-no[data-v-5c2b8efa]{background:#fff3e8;color:#ff7d00}.score-header[data-v-5c2b8efa]{display:inline-block;cursor:help;line-height:1.2;vertical-align:middle}.score-header-title[data-v-5c2b8efa]{display:block;white-space:nowrap}.score-header-sub[data-v-5c2b8efa]{display:block;margin-top:2px;color:#9ca3af;font-size:10px;font-weight:400;line-height:1.2;white-space:nowrap}[data-v-5c2b8efa] .score-header-cell .caret-wrapper{vertical-align:top}[data-v-5c2b8efa] .performance-table .el-table__fixed-header-wrapper th,[data-v-5c2b8efa] .performance-table .el-table__header-wrapper th{background-color:#f5f7fa}[data-v-5c2b8efa] .performance-table .el-table__header th>.cell{white-space:nowrap}[data-v-5c2b8efa] .performance-table .el-table__body tr.el-table__row--striped td{background-color:#fafafa}[data-v-5c2b8efa] .performance-table .el-table__body td.performance-num-cell>.cell{font-weight:600}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/pages/InternAuditPerformanceTable.vue"],"names":[],"mappings":"AACA,8BAA8B,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,kBAAkB,CACnJ,AACD,wCAAwC,WAAW,CAClD,AACD,mCAAmC,aAAa,aAAa,CAC5D,AACD,mCAAmC,eAAe,CACjD,AACD,iEAAiE,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,gBAAgB,oBAAoB,eAAe,aAAa,CAC5Q,AACD,iCAAiC,mBAAmB,aAAa,CAChE,AACD,gCAAgC,mBAAmB,aAAa,CAC/D,AACD,+BAA+B,qBAAqB,YAAY,gBAAgB,qBAAqB,CACpG,AACD,qCAAqC,cAAc,kBAAkB,CACpE,AACD,mCAAmC,cAAc,eAAe,cAAc,eAAe,gBAAmB,gBAAgB,kBAAkB,CACjJ,AACD,oDAAoD,kBAAkB,CACrE,AACD,0IAA0I,wBAAwB,CACjK,AACD,gEAAgE,kBAAkB,CACjF,AACD,kFAAkF,wBAAwB,CACzG,AACD,mFAAmF,eAAe,CACjG","file":"InternAuditPerformanceTable.vue","sourcesContent":["\n.score-range[data-v-5c2b8efa]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.score-range .el-input[data-v-5c2b8efa]{width:120px\n}\n.score-range span[data-v-5c2b8efa]{margin:0 8px;color:#909399\n}\n.score-range-item[data-v-5c2b8efa]{margin-bottom:0\n}\n.attendance-yes[data-v-5c2b8efa],.attendance-no[data-v-5c2b8efa]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:2px 8px;border-radius:999px;font-size:12px;line-height:1\n}\n.attendance-yes[data-v-5c2b8efa]{background:#E8FFF3;color:#00B42A\n}\n.attendance-no[data-v-5c2b8efa]{background:#FFF3E8;color:#FF7D00\n}\n.score-header[data-v-5c2b8efa]{display:inline-block;cursor:help;line-height:1.2;vertical-align:middle\n}\n.score-header-title[data-v-5c2b8efa]{display:block;white-space:nowrap\n}\n.score-header-sub[data-v-5c2b8efa]{display:block;margin-top:2px;color:#9ca3af;font-size:10px;font-weight:normal;line-height:1.2;white-space:nowrap\n}\n[data-v-5c2b8efa] .score-header-cell .caret-wrapper{vertical-align:top\n}\n[data-v-5c2b8efa] .performance-table .el-table__header-wrapper th,[data-v-5c2b8efa] .performance-table .el-table__fixed-header-wrapper th{background-color:#f5f7fa\n}\n[data-v-5c2b8efa] .performance-table .el-table__header th>.cell{white-space:nowrap\n}\n[data-v-5c2b8efa] .performance-table .el-table__body tr.el-table__row--striped td{background-color:#fafafa\n}\n[data-v-5c2b8efa] .performance-table .el-table__body td.performance-num-cell>.cell{font-weight:600\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3258:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3259);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("73998927", content, true, {});

/***/ }),

/***/ 3259:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".score-header-popper{width:256px;line-height:1.625;font-size:11px;font-weight:400;text-align:left}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/pages/InternAuditPerformanceTable.vue"],"names":[],"mappings":"AACA,qBAAqB,YAAY,kBAAkB,eAAe,gBAAmB,eAAe,CACnG","file":"InternAuditPerformanceTable.vue","sourcesContent":["\n.score-header-popper{width:256px;line-height:1.625;font-size:11px;font-weight:normal;text-align:left\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("实习生管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("审单绩效统计")])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"rules":_vm.formRules,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"出勤月份","prop":"stat_month"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"type":"month","value-format":"yyyy-MM","placeholder":"请选择出勤月份","clearable":""},model:{value:(_vm.search.stat_month),callback:function ($$v) {_vm.$set(_vm.search, "stat_month", $$v)},expression:"search.stat_month"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"输入客户名称/编号搜索","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},on:{"change":_vm.onCustomerChange},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称","prop":"projectid"}},[_c('remote-select',{key:_vm.projectSelectKey,staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"输入项目名称/编号搜索","query-request":_vm.queryProjectTable,"find-request":_vm.getProjectDetail},on:{"change":_vm.onProjectChange},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"绩效分"}},[_c('div',{staticClass:"score-range"},[_c('el-form-item',{staticClass:"score-range-item",attrs:{"prop":"score_min"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"最低分"},model:{value:(_vm.search.score_min),callback:function ($$v) {_vm.$set(_vm.search, "score_min", $$v)},expression:"search.score_min"}})],1),_vm._v(" "),_c('span',[_vm._v("~")]),_vm._v(" "),_c('el-form-item',{staticClass:"score-range-item",attrs:{"prop":"score_max"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"最高分"},model:{value:(_vm.search.score_max),callback:function ($$v) {_vm.$set(_vm.search, "score_max", $$v)},expression:"search.score_max"}})],1)],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"实习生","prop":"intern_user_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","placeholder":"请输入账号名搜索","query-request":_vm.queryInternTableApi,"find-request":_vm.getInternBaseInfoApi},model:{value:(_vm.search.intern_user_id),callback:function ($$v) {_vm.$set(_vm.search, "intern_user_id", $$v)},expression:"search.intern_user_id"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh"},on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"sj-icon-export"},on:{"click":function($event){return _vm.onExport()}}},[_vm._v("导出\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-s-data","loading":_vm.recalculating},on:{"click":function($event){return _vm.onManualRecalculate()}}},[_vm._v("重新手动计算\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('el-table',{ref:"performanceTable",staticClass:"performance-table",attrs:{"data":_vm.table,"default-sort":_vm.defaultSort,"stripe":"","highlight-current-row":"","border":""},on:{"sort-change":_vm.onSortChange}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"实习生","width":"140","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.internText(scope.row))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"stat_month","label":"出勤月份","width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer_name","label":"客户","width":"140","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"项目","width":"220","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.projectText(scope.row))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"audit_order_total","label":"审核工单总数","width":"130","class-name":"performance-num-cell","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_full_attendance","label":"是否全勤","width":"110","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{class:Number(scope.row.is_full_attendance) === 1 ? 'attendance-yes' : 'attendance-no'},[_vm._v("\n            "+_vm._s(Number(scope.row.is_full_attendance) === 1 ? '是' : '否')+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"plan_order_total","label":"累计审核目标","width":"130","class-name":"performance-num-cell","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"pass_count","label":"通过次数","width":"110","class-name":"performance-num-cell","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reject_count","label":"不通过次数","width":"120","class-name":"performance-num-cell"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"first_audit_count","label":"初审次数","width":"110","class-name":"performance-num-cell"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"review_audit_count","label":"复审次数","width":"110","class-name":"performance-num-cell"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"wrong_order_total","label":"误审单量","width":"110","class-name":"performance-num-cell"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"days_target_achieved","label":"目标达成天数","width":"130","class-name":"performance-num-cell","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"days_target_onduty","label":"项目出勤天数","width":"130","class-name":"performance-num-cell","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"target_score","label":"目标达成率（得分）","width":"220","class-name":"performance-num-cell","label-class-name":"score-header-cell","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.achieve_rate_text)+"\n        ")]}}])},[_c('template',{slot:"header"},[_c('el-tooltip',{attrs:{"placement":"bottom-start","effect":"dark","popper-class":"score-header-popper"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n              目标达成率 = 目标达成天数 / 项目出勤天数"),_c('br'),_vm._v("\n              分数折算："),_c('br'),_vm._v("\n              ≥ 100%：45 分"),_c('br'),_vm._v("\n              90% ≤ 达成率 < 100%：42 分"),_c('br'),_vm._v("\n              80% ≤ 达成率 < 90%：38 分"),_c('br'),_vm._v("\n              70% ≤ 达成率 < 80%：20 分"),_c('br'),_vm._v("\n              < 70%：5 分\n            ")]),_vm._v(" "),_c('span',{staticClass:"score-header"},[_c('span',{staticClass:"score-header-title"},[_vm._v("目标达成率（得分）")]),_vm._v(" "),_c('span',{staticClass:"score-header-sub"},[_vm._v("目标达成天数/项目出勤天数")])])])],1)],2),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"accuracy_score","label":"错误率（得分）","width":"200","class-name":"performance-num-cell","label-class-name":"score-header-cell","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.error_rate_text)+"\n        ")]}}])},[_c('template',{slot:"header"},[_c('el-tooltip',{attrs:{"placement":"bottom-start","effect":"dark","popper-class":"score-header-popper"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n              错误率 = 错审单量 / 项目审单量"),_c('br'),_vm._v("\n              分数折算："),_c('br'),_vm._v("\n              错误率 ≤ 2%：45 分"),_c('br'),_vm._v("\n              2% < 错误率 ≤ 5%：40 分"),_c('br'),_vm._v("\n              5% < 错误率 ≤ 10%：35 分"),_c('br'),_vm._v("\n              错误率 > 10%：0 分\n            ")]),_vm._v(" "),_c('span',{staticClass:"score-header"},[_c('span',{staticClass:"score-header-title"},[_vm._v("错误率（得分）")]),_vm._v(" "),_c('span',{staticClass:"score-header-sub"},[_vm._v("错审单量/项目审单量")])])])],1)],2),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"attendance_score","label":"月度出勤得分","width":"130","class-name":"performance-num-cell","label-class-name":"score-header-cell","sortable":"custom"}},[_c('template',{slot:"header"},[_c('el-tooltip',{attrs:{"placement":"bottom-start","effect":"dark","popper-class":"score-header-popper"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n              全勤：10 分"),_c('br'),_vm._v("\n              非全勤：0 分\n            ")]),_vm._v(" "),_c('span',{staticClass:"score-header"},[_c('span',{staticClass:"score-header-title"},[_vm._v("月度出勤得分")])])])],1)],2),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_score","label":"审单绩效总分","width":"140","class-name":"performance-num-cell","sortable":"custom"}})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/audit-intern-performance.9c9fab792c3024422a9b.js